export class Cuenta{
    id: string;
    name: string;
}